import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a309deac"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "mod_columns" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'mod_columns',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        innerHTML: __props.d.body
                    }, null, 8, _hoisted_3),
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'columns',
                            `columns--${__props.d.alignment[0]}`,
                            `align--${__props.d.text_align[0]}`,
                            `cols--min${__props.d.min_cols}`,
                            `cols--max${__props.d.max_cols}`
                        ])
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.columns, (column, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "column",
                                key: index,
                                innerHTML: column.column
                            }, null, 8, _hoisted_4));
                        }), 128))
                    ], 2)
                ])
            ]));
        };
    }
});
